import React, { useState, useEffect } from "react";
import "./HomePage.css";
import { useNavigate } from "react-router-dom";
import Footer from "../admin/Footer";
import Header from "../admin/Header";
import { API } from './api.js';

const HomePage = () => {
  const [agreed, setAgreed] = useState(false);
  const [formOpen, setFormOpen] = useState(true); // default to true
  const navigate = useNavigate();

  const handleCheckboxChange = (e) => {
    setAgreed(e.target.checked);
  };

  useEffect(() => {
    fetch(API.getFormStatus)
      .then((res) => res.json())
      .then((data) => {
        if (data.flag === 1) {
          setFormOpen(true);  // Form is open
        } else {
          setFormOpen(false); // Form is closed
        }
      })
      .catch((error) => {
        console.error("Error fetching form status:", error);
        setFormOpen(false); // Safe fallback
      });
  }, []);

  return (
    <>
      <Header />
      <div className="home-container">
        <div className="guidelines-box" style={{marginTop: "120px"}}>
          {!formOpen ? (
            <h2 className="form-closed-message">
        अर्ज भरण्याची अंतिम तारीख संपली आहे. धन्यवाद !
      </h2>
          ) : (
            <>
              <h1 className="home-title">सूचना</h1>
              <ul>
                <li>इच्छुक उमेदवारांनी आपली परिपूर्ण माहिती १६.०४.२०२५ ते २२.०४.२०२५ अखेर नोंदवावी.</li>
                <li>सदरची नोंदणी २२.०४.२०२५ रोजी रात्री १२.०० वाजता बंद होईल. </li>
                <li>सर्व आकडेवारी इंग्रजीत भरणेची आहे. </li>
                <li>आपण भरलेल्या अर्जाची प्रत नोंदणी केलेल्या ईमेल ला पाठवण्यात येईल.</li>
              </ul>

              <div className="checkbox-section">
                <label className="checkbox-label">
                  <input
                    type="checkbox"
                    checked={agreed}
                    onChange={handleCheckboxChange}
                  />
                  मी वरील माहिती वाचली आहे.
                </label>
              </div>

              {agreed && (
                <div className="post-selection">
                  <h2 className="home-title">पोस्ट निवडा</h2>
                  <div className="card-container">
                    <div
                      className="position-card"
                      onClick={() => {
                        sessionStorage.setItem("selectedPost", "1");
                        navigate("/clerk-form");
                      }}
                    >
                      <h4>कनिष्ठ लिपिक पदासाठी अर्ज</h4>
                    </div>

                    <div
                      className="position-card"
                      onClick={() => {
                        sessionStorage.setItem("selectedPost", "2");
                        navigate("/assistance-form");
                      }}
                    >
                      <h4>प्रयोगशाळा सहाय्यक पदासाठी अर्ज</h4>
                    </div>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default HomePage;